import { createFileRoute } from "@tanstack/react-router";
import { BOARD, CarouselStudio } from "../features/social-carousel/carousel-studio";

export const Route = createFileRoute("/carousel")({
  component: CarouselPage,
});

function CarouselPage() {
  return <CarouselStudio board={BOARD} />;
}
